import Form from '@arivaa-react/components/form';

export function EditFooterCopyright() {
  const handleSubmit = async (values) => {
    console.log(values);
  };
  return (
    <div className="card">
      <div className="heading">
        <p className="label">Edit Copyright</p>
      </div>
      <div className="edit-form">
        <Form
          renderForm={({ renderElement }) => {
            return (
              <div className="item">
                {renderElement({
                  type: 'text',
                  name: 'title',
                  label: 'Copyright',
                  required: true,
                  options: {
                    initialValue: '',
                  },
                })}
              </div>
            );
          }}
          onSubmit={handleSubmit}
          submitButtonProps={{
            children: 'Save',
          }}
        />
      </div>
    </div>
  );
}
